export const EmployeeReviewStatus = {
  Draft: 0,
  Submitted: 1,
  PendingManagerReview: 2,
  SubmittedByAllParticipants: 3,
  Finished: 4,
} as const;

export type EmployeeReviewStatus = (typeof EmployeeReviewStatus)[keyof typeof EmployeeReviewStatus];

export const employeeReviewStatusLabels: Record<EmployeeReviewStatus, string> = {
  [EmployeeReviewStatus.Draft]: 'Draft',
  [EmployeeReviewStatus.Submitted]: 'Submitted',
  [EmployeeReviewStatus.PendingManagerReview]: 'Pending Manager Review',
  [EmployeeReviewStatus.SubmittedByAllParticipants]: 'Submitted by all participants',
  [EmployeeReviewStatus.Finished]: 'Finished',
};
